// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"37a1da06","248":"d6ce2105","257":"ff1b1aab","279":"e57f4fc7","576":"84041a91","841":"05de157c","886":"fd8a9611","922":"7e06edcb","971":"a83feefa"}[chunkId] + ".chunk.js";
};